// extracted by mini-css-extract-plugin
export default {"inputStyle":"UpcommingProjectListing_inputStyle__xuoVF","searchIcon":"UpcommingProjectListing_searchIcon__3+FR1"};